import { Link } from "react-router";
import { ROUTES } from "@/shared/constants/routes";
import { cn } from "@/shared/ui/cn";
import { SIGNUP_ACCEPTANCE } from "./wording";

/** The two public documents, at the foot of every page a person sees before they have an organisation. */
export function LegalLinks({ className }: { className?: string }) {
  return (
    // Wraps between links, never inside one: on a 320 px phone the three no longer fit on a line, and "Terms of /
    // Service" broken across two lines reads as two links.
    <nav
      aria-label="Legal documents"
      className={cn("flex flex-wrap gap-x-4 gap-y-1 text-caption", className)}
    >
      <Link to={ROUTES.legalTerms} className="whitespace-nowrap">
        {SIGNUP_ACCEPTANCE.termsLabel}
      </Link>
      <Link to={ROUTES.legalPrivacy} className="whitespace-nowrap">
        {SIGNUP_ACCEPTANCE.privacyLabel}
      </Link>
      <Link to={ROUTES.accountDeletion} className="whitespace-nowrap">
        Account deletion
      </Link>
    </nav>
  );
}
